import enums from '@/libs/enums'
import Http from '@/libs/http/request'
import { appStore, userStore } from '@/stores'

export const checkUsernameExists = params => {
  // 检测账号是否存在
  return Http.request({
    url: `/v1/user/checkUsernameExists`,
    showError: false,
    params,
    method: 'get',
  })
}

export const getCommonEmailDomains = () => {
  // 获取常用邮箱后缀
  return Http.request({
    url: '/v1/common/getCommonEmailDomains',
    showError: false,
    method: 'get',
  })
}

export const getEmailCaptcha = data => {
  let url = '/v1/user/emailCaptcha'
  if (data.type === enums.sendCaptchaType.createCompany && appStore.useZgaApi) {
    url = appStore.zgaApiHost + '/v1/user/emailCaptcha'
  }
  // 发送邮箱验证码
  return Http.request({
    url,
    data,
    method: 'post',
  })
}

export const getSmsCaptcha = data => {
  let url = '/v1/user/smsCaptcha'
  if (data.type === enums.sendCaptchaType.createCompany && appStore.useZgaApi) {
    url = appStore.zgaApiHost + url
  }
  // 发送短信验证码
  return Http.request({
    url,
    data,
    method: 'post',
  })
}

export const verifyCaptcha = data => {
  // 检查验证码
  return Http.request({
    url: '/v1/user/verifyCaptcha',
    data,
    method: 'post',
  })
}

export const resetPassword = data => {
  // 重置密码
  return Http.request({
    url: '/v1/user/resetPassword',
    data,
    method: 'post',
  })
}

export const reportLogin = data => {
  // 登录后上报登录的终端，产品名，语言等数据
  return Http.request({
    url: '/v1/user/reportLogin',
    data,
    showError: false,
    timeout: 3000,
    method: 'post',
  })
}

export const userLogin = data => {
  // 登录
  data.shareKey = userStore.shareKey
  data.shareType = userStore.shareType
  return Http.request({
    url: '/v1/user/login',
    data,
    method: 'post',
  })
}

export const companyInviteLogin = data => {
  // 企业邀请注册
  return Http.request({
    url: '/v1/user/companyInviteLogin',
    data,
    method: 'post',
  })
}

export const getCompanyAccountList = params => {
  // 获取已登录用户账号下其他企业账号
  return Http.request({
    url: `/v1/user/getCompanyAccountList`,
    params,
    method: 'get',
  })
}

export const selectAccountLogin = companyId => {
  // 选择账号进行登录
  return Http.request({
    url: `/v1/user/loginCompanyAccount/${companyId}`,
    method: 'post',
  })
}

export const hasCompanyByInviteCode = inviteCode => {
  // 通过邀请码查询企业名称和邀请人姓名
  return Http.request({
    url: `/v1/user/hasCompanyByInviteCode/${inviteCode}`,
    method: 'get',
  })
}

export const userQuickLogin = data => {
  // 快捷注册
  data.shareKey = userStore.shareKey
  data.shareType = userStore.shareType
  return Http.request({
    url: '/v1/user/quickLogin',
    data,
    method: 'post',
  })
}

export const getActivity = placement => {
  // 获取活动:placement=webLoginSuccess(登录成功)
  return Http.request({
    url: '/v1/common/marketingActivity',
    params: {
      placement,
    },
    showError: false,
    method: 'get',
  })
}

export const getAuthCode = () => {
  // 通过token获取code
  return Http.request({
    url: '/v1/user/getAuthCode',
    method: 'get',
  })
}

export const getTokenByCode = code => {
  // 通过code获取token
  return Http.request({
    url: `/v1/user/getTokenByCode/${code}`,
    method: 'get',
  })
}

export const getWechatLoginQrcode = () => {
  // 获取微信登录二维码
  return Http.request({
    url: '/v1/user/wxQrCode',
    method: 'get',
  })
}

export const checkWechatQrcodeLogin = ticket => {
  // 获取微信登录状态
  return Http.request({
    url: `/v1/user/wxCheckQrCodeLogin/${ticket}`,
    params: {
      shareKey: userStore.shareKey,
      shareType: userStore.shareType,
    },
    showError: false,
    method: 'get',
  })
}

export const getTokenByAppAuthCode = appAuthCode => {
  // 通过appAuthCode轮询获取登录状态
  return Http.request({
    url: `/v1/user/getTokenByAppAuthCode/${appAuthCode}`,
    showError: false,
    method: 'get',
  })
}

export const checkSSOEmailExist = params => {
  // SSO 登录
  return Http.request({
    url: '/v1/saml/checkSSOEmailExist',
    method: 'get',
    params,
  })
}

export const ssoLoginCallback = reqId => {
  // SSO 登录成功信息
  return Http.request({
    url: `/v1/saml/loginSuccess/${reqId}`,
    method: 'get',
    showError: false,
  })
}

export const googleLogin = params => {
  // 获取谷歌登录相关信息
  return Http.request({
    url: '/v1/user/googleLogin',
    method: 'get',
    params,
  })
}

export const googleQuickLogin = data => {
  // 获取谷歌快捷登录相关信息(通过token获取)
  data.shareKey = userStore.shareKey
  data.shareType = userStore.shareType
  return Http.request({
    url: '/v1/user/googleQuickLogin',
    method: 'post',
    data,
  })
}

export const googleLoginCallback = params => {
  // 通过谷歌回调参数注册并获取用户信息
  params.shareKey = userStore.shareKey
  params.shareType = userStore.shareType
  return Http.request({
    url: '/v1/user/googleLoginCallback',
    method: 'get',
    params,
  })
}

export const appleLogin = params => {
  // 获取苹果登录相关信息
  return Http.request({
    url: '/v1/user/appleLogin',
    method: 'get',
    params,
  })
}

export const appleCheckLogin = code => {
  // 检测苹果登录返回用户信息
  return Http.request({
    url: `/v1/user/appleCheckLogin/${code}`,
    method: 'get',
    params: {
      shareKey: userStore.shareKey,
      shareType: userStore.shareType,
    },
  })
}

export const setUserInfo = data => {
  // 修改用户信息
  return Http.request({
    url: '/v1/user/setUserInfo',
    data,
    method: 'post',
  })
}

export const getPlanList = () => {
  // // 获取订阅类型
  // let url = '/v1/order/planList'
  // // 正式环境强制使用.com获取订阅类型(否则国内.cn下取消订阅后立马读取刷新plan会出现数据还没同步过去的情况)
  // if (import.meta.env.MODE === 'prod') {
  //   url = import.meta.env.VITE_API_PREFIX_EN + url
  // }
  let url = `/v1/order/planList`
  if (appStore.useZgaApi) {
    // 国内使用新的域名
    url = appStore.zgaApiHost + url
  }
  return Http.request({
    url,
    method: 'get',
  })
}

export const getUserBasePlanList = () => {
  // 获取用户基础plan列表
  return Http.request({
    url: '/v1/user/getUserBasePlanList',
    method: 'get',
  })

}

export const cancelSubscription = planId => {
  // 取消订阅
  return Http.request({
    url: `/v1/order/cancelSubscription/${planId}`,
    method: 'post',
  })
}

export const activeSubscription = planId => {
  // 激活订阅
  return Http.request({
    url: `/v1/order/activeSubscription/${planId}`,
    method: 'post',
  })
}

export const getSubscriptionMoney = planId => {
  // 激活订阅金额
  return Http.request({
    url: `/v1/order/getUserPlanSubPrice/${planId}`,
    method: 'get',
  })
}

export const postSubBySubPrice = planId => {
  // 更改订阅金额
  return Http.request({
    url: `/v1/order/subBySubPrice/${planId}`,
    method: 'post',
  })
}

export const usePlan = planId => {
  // 激活赠品Plan
  return Http.request({
    url: `/v1/order/planUse/${planId}`,
    method: 'post',
  })
}

export const getOffsetCoupon = code => {
  // 获取兑换码类型
  return Http.request({
    url: `/v1/active/offsetCoupon/${code}`,
    showError: false,
    method: 'get',
  })
}

/**
 * 兑换兑换码
 * @param {*} code 兑换码
 * @param {*} retry 是否是重试（重试时不走zga）
 * @returns
 */
export const useOffsetCoupon = (code, retry = false) => {
  let url = `/v1/active/useOffsetCoupon/${code}`
  if (appStore.useZgaApi && !retry) {
    // 国内使用新的域名
    url = appStore.zgaApiHost + `/v1/active/useOffsetCoupon/${code}`
  }
  // 使用兑换码兑换
  return Http.request({
    url,
    // showError: false,
    method: 'post',
  })
}

export const uploadFile = data => {
  // 文件上传
  return Http.request({
    url: '/v1/file/upload',
    data,
    method: 'put',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const uploadStream = data => {
  // 文件流上传
  return Http.request({
    url: '/v1/file/uploadStream',
    data,
    method: 'put',
  })
}

/**
 * 获取用户信息
 * @param {Boolean} gotoLoginWhenTokenError 是否当token失效时跳转登录页，默认跳转
 * @returns
 */
export const getUserInfo = (gotoLoginWhenTokenError = true) => {
  return Http.request({
    url: '/v1/user/getUserInfo',
    showError: false,
    gotoLoginWhenTokenError,
    method: 'get',
  })
}

export const logOut = () => {
  // 退出登录
  return Http.request({
    url: '/v1/user/logout',
    showError: false,
    method: 'post',
  })
}

export const deleteAccount = () => {
  // 删除账号
  return Http.request({
    url: '/v1/user/delete',
    method: 'delete',
  })
}

export const getGoogleUserInfo = accessToken => {
  // 获取谷歌登录用户信息
  return Http.request({
    url: `https://www.googleapis.com/plus/v1/people/me?access_token=${accessToken}`,
    method: 'get',
  })
}

export const bindAccount = data => {
  // 用户绑定手机号或邮箱
  return Http.request({
    url: '/v1/user/bindAccount',
    data,
    method: 'post',
  })
}

export const getAppleBinding = (params) => {
  // 苹果账号绑定
  return Http.request({
    url: '/v1/user/appleBind',
    method: 'get',
    params
  })
}

export const getGoogleBinding = (params) => {
  // 谷歌账号绑定
  return Http.request({
    url: '/v1/user/googleBind',
    method: 'get',
    params
  })
}

export const getWeChatBinding = (params) => {
  // 微信账号绑定
  return Http.request({
    url: '/v1/user/wxBindQrCode',
    method: 'get',
    params
  })
}

export const getWeChatBindingRes = (ticket, params) => {
  // 获取微信账号绑定接口
  return Http.request({
    url: `/v1/user/wxCheckBindQrCode/${ticket}`,
    params,
    showError: false, // 如果报错，不用提示
    method: 'get',
  })
}

export const getBindThirdParties = () => {
  // 获取第三方账号绑定接口：google,apple,wechat
  return Http.request({
    url: '/v1/user/getBindThirdParties',
    method: 'post',
  })
}

export const unbindThirdParty = data => {
  // 解绑第三方账号绑定接口：google,apple,wechat
  return Http.request({
    url: '/v1/user/unBindThirdParties',
    data,
    method: 'post',
  })
}

export const getPaymentMethodList = () => {
  // 获取panyment list
  return Http.request({
    url: `/v1/order/paymentMethodList`,
    method: 'get',
  })
}

export const unbindPaymentCard = (orderNo) => {
  // 解绑信用卡
  return Http.request({
    url: `/v1/order/unbindAuthCard/${orderNo}`,
    method: 'put',
  })
}

export const getOrderList = () => {
  // 获取orderment list
  return Http.request({
    url: `/v1/order/orderList`,
    method: 'get',
  })
}
export const getRepayUrl = orderNo => {
  return Http.request({
    url: `/v1/order/getRepayUrl/${orderNo}`,
    showError: false, // 如果报错，不用提示
    method: 'get',
  })
}
export const orderBindAuthCard = data => {
  const newData = {
    bindOrderNo: data.bindOrderNo,
  }

  return Http.request({
    url: `/v1/order/orderBindAuthCard/${data.orderNo}`,
    data: newData,
    method: 'put',
  })
}

export const getDeviceList = () => {
  let url = `/v1/user/getDeviceList`
  if (appStore.useZgaApi) {
    // 国内使用新的域名
    url = appStore.zgaApiHost + url
  }
  return Http.request({
    url,
    method: 'get',
    showError: false,
  })
}
export const logOutDevice = id => {
  return Http.request({
    url: `/v1/user/weekOutDevice/${id}`,
    method: 'post',
  })
}
export const createCNInvoice = data => {
  // 创建国内发票信息
  return Http.request({
    url: '/v1/order/createCNInvoice',
    data,
    method: 'post',
  })
}
export const createENInvoice = data => {
  // 创建海外发票信息
  return Http.request({
    url: '/v1/order/createENInvoice',
    data,
    method: 'post',
  })
}

export const getInvoiceUrl = orderNo => {
  return Http.request({
    url: `/v1/order/getInvoiceUrl/${orderNo}`,
    showError: true,
    method: 'get',
  })
}

// 邮箱是否在白名单中
export const isEdmBlackList = data => {
  return Http.request({
    url: `/v1/edm/isEdmBlackList`,
    data,
    method: 'post',
  })
}

// 取消订阅
export const unSubEdm = data => {
  return Http.request({
    url: `/v1/edm/unSubEdm`,
    data,
    method: 'post',
  })
}

// 恢复订阅
export const reSubEdm = data => {
  return Http.request({
    url: `/v1/edm/subEdm`,
    data,
    method: 'post',
  })
}

/**
 * 提交用户营销数据
 * @param {Object} data 
 * @property {String} daa.howToPlanUse 计划如何使用
 * @property {String} daa.howHeaderUs 通过什么了解我们
 * @property {String} daa.whatFeatureToUse 使用什么功能
 * @property {Number} daa.ageMin 最小年龄
 * @property {Number} daa.ageMax 最大年龄
 * @property {String} daa.work 工作是什么
 * @returns 
 */
export const marketingReport = data => {
  return Http.request({
    url: `/v1/user/marketingReport`,
    data,
    method: 'post',
  })
}